import {createGlobalStyle} from 'styled-components'

export default createGlobalStyle`
  *, *::before, *::after {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    background-color: #0F0B30;
    color: #fff;
    font-family: 'Poppins', sans-serif;
    overflow-x: hidden;
  }
`;
